import React, { useState } from 'react'
import firebase from '../util/firebase.js';
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { useAuth } from "../util/auth.js";
import { useRouter } from "./../util/router.js";
// import { FaRegThumbsUp } from "react-icons/fa";
// import { FaRegThumbsDown } from "react-icons/fa";
// import './CoffeeAvailability.scss'

function CoffeeAvailability(props) {
    const auth = useAuth();
    const router = useRouter();
    const [votedText, setVotedText] = useState("Coffee Still Available?");
    const [showButton, setShowButton] = useState(true);
    const { coffeeId } = props;

    //    const resetVote = async () => {    
    //     const coffeeVoteRef = firebase.firestore().collection('coffee').doc(coffeeId);    
    //        //if has received +5 votes, will reset counter and list as available
    //     if (props.coffeeAvailabilityVote >= 5) {
    //     console.log("resetVote >= 5 and reset coffeeAvailabilityVote to 0 and coffeeAvailability to Likely Available");       
    //      await coffeeVoteRef.update({
    //          coffeeAvailability: "Likely Available",
    //          coffeeAvailabilityVote: 0,
    //          })

    //      } else if (props.coffeeAvailabilityVote <= -5) {
    //          //if has received -5 votes, will reset counter and list as sold out   
    //         console.log("update has run: resetVote <= 5 and reset coffeeAvailabilityVote to 0 and coffeeAvailability to Possible Sold Out");     
    //         await coffeeVoteRef.update({
    //             coffeeAvailability: "Possibly Sold Out",
    //             coffeeAvailabilityVote: 0,
    //         })}
    // }

    const handleVoteClickYes = async (e) => {
        if (!auth.user) {
            router.push("/auth/signup")
    
            } else {
           //Hide buttons onClick
           setShowButton(false);
           setVotedText("Thank you for helping others know it is still available!");
           await votingYesTransaction();
        }           
       }  

       const handleVoteClickNo = async () => {
        if (!auth.user) {
            router.push("/auth/signup")
    
            } else {
           //Hide buttons onClick
           setShowButton(false);
           setVotedText("Thank you for letting others no it is no longer available")
           await votingNoTransaction();}
       } 
       
       const votingYesTransaction = async () => {
        const userVoteRef = firebase.firestore().doc(`/coffee/${coffeeId}/voting/${firebase.auth().currentUser.uid}_${coffeeId}`);
        const coffeeVoteRef = firebase.firestore().collection('coffee').doc(coffeeId);
        try {
          await firebase.firestore().runTransaction(async t => {
             //read coffeeDoc first 
            const coffeeDoc = await t.get(coffeeVoteRef);
            const currentVote = coffeeDoc.data().coffeeAvailabilityVote + 1;

            //read userDoc 
            const userDoc = await t.get(userVoteRef);
            //check if userDoc exits (or voted before)
            if (userDoc.exists) {
            const oldUserCoffeeAvailabilityVote = userDoc.data().coffeeAvailability;           

            //if prev vote was opposite, give 2 points instead of 1
            if (oldUserCoffeeAvailabilityVote === false) {                
                await t.set(userVoteRef, {
                    coffeeAvailability: true,
                    createdTime: firebase.firestore.FieldValue.serverTimestamp(),
                    uid: auth.user.id,
                    coffeeId: coffeeId,                   
                });

                await t.update(coffeeVoteRef, {
                    coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(+2) 
                })
                
            } else if (oldUserCoffeeAvailabilityVote === true) {
                //do nothing since vote is the same
            }  
        } else {
            //has not prev voted, give 1 point
            await t.set(userVoteRef, {
                coffeeAvailability: true,
                createdTime: firebase.firestore.FieldValue.serverTimestamp(),
                uid: auth.user.id,
                coffeeId: coffeeId,                   
            });

            await t.update(coffeeVoteRef, {
                coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(+1) 
            })            
        }
        //reset vote
        if (currentVote >= 5) {
            await t.update(coffeeVoteRef, {
                coffeeAvailability: "Likely Available",
                coffeeAvailabilityVote: 0,
            })
        }
            console.log("votingTransaction has executed successfully")
          })
        } catch (e){
          console.log("votingTransaction failure:", e)
        }
      }

      const votingNoTransaction = async () => {
        const userVoteRef = firebase.firestore().doc(`/coffee/${coffeeId}/voting/${firebase.auth().currentUser.uid}_${coffeeId}`);
        const coffeeVoteRef = firebase.firestore().collection('coffee').doc(coffeeId);
        try {
          await firebase.firestore().runTransaction(async t => {
             //read coffeeDoc first 
            const coffeeDoc = await t.get(coffeeVoteRef);
            const currentVote = coffeeDoc.data().coffeeAvailabilityVote - 1;

            //read userDoc 
            const userDoc = await t.get(userVoteRef);
            //check if userDoc exits (or voted before)
            if (userDoc.exists) {
            const oldUserCoffeeAvailabilityVote = userDoc.data().coffeeAvailability;           

            //if prev vote was opposite, give -2 points instead of -1
            if (oldUserCoffeeAvailabilityVote === true) {
                await t.set(userVoteRef, {
                    coffeeAvailability: false,
                    createdTime: firebase.firestore.FieldValue.serverTimestamp(),
                    uid: auth.user.id,
                    coffeeId: coffeeId,                   
                });

                await t.update(coffeeVoteRef, {
                    coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(-2) 
                })
            } else if (oldUserCoffeeAvailabilityVote === false) {
                //do nothing since vote is the same
            }  
        } else {
            //has not prev voted, give -1 point
            await t.set(userVoteRef, {
                coffeeAvailability: false,
                createdTime: firebase.firestore.FieldValue.serverTimestamp(),
                uid: auth.user.id,
                coffeeId: coffeeId,                   
            });

            await t.update(coffeeVoteRef, {
                coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(-1) 
            })            
        }
        //reset vote
        if (currentVote <= -5) {
            await t.update(coffeeVoteRef, {
                coffeeAvailability: "Possibly Sold Out",
                coffeeAvailabilityVote: 0,
            })
        }
            console.log("votingNoTransaction has executed successfully")
          })
        } catch (e){
          console.log("votingNoTransaction failure:", e)
        }
      }
       

    return (
            <div>

            {votedText}

            {showButton && 

            <ButtonGroup className="float-right" aria-label="Coffee Availability">

            <Button 
            variant="light"
            value="Yes"
            onClick={() => handleVoteClickYes()}
            >
                Yes
            </Button>

            <Button 
            variant="light"
            value="No"
            onClick={() => handleVoteClickNo()}
            >
                No
            </Button>
            </ButtonGroup>}
            </div>
    )
}

export default CoffeeAvailability

//return divs before changing buttons to 2 buttons
// {/* <div>

// {votedText}

// {showButton && ["Yes", "No"].map(buttonValue =>
//     <Button
//         key={buttonValue}
//         size="sm mx-1"
//         value={buttonValue}
//         variant={(buttonValue === "Yes") ? "outline-success" : "outline-danger"}
//         onClick={(e) => handleVoteClick(e)}
//         >
//             {buttonValue}
//     </Button>
//     )}
// </div> */}

//2 buttons that isn't working because adjacent JSX
// {/* <div>

// {votedText}

// {showButton && 
// (<Button
//     size="sm mx-1"
//     variant={"outline-success"}
//     onClick={(e) => handleVoteClick(yes)}
//     >
//         Yes 
// </Button>

// <Button
//     size="sm mx-1"
//     variant={"outline-danger"}
//     onClick={(e) => handleVoteClick(yes)}
//     >
//     No 
// </Button>
//     )}
// </div> */}

// const handleVoteClick = async (e) => {
//     if (!auth.user) {
//         router.push("/auth/signup")

//         } else {
    
//        //Hide buttons onClick
//        setShowButton(false);
//        //reset counter to 0 and new coffee availability
//         resetVote();
//        const userVoteRef = firebase.firestore().doc(`/coffee/${coffeeId}/voting/${firebase.auth().currentUser.uid}_${coffeeId}`);
//        const coffeeVoteRef = firebase.firestore().collection('coffee').doc(coffeeId);
//        const batch = firebase.firestore().batch();
//        const doc = await userVoteRef.get();           

//        if (doc.exists) {
//         if (doc.data().coffeeAvailability === false && e.target.value === "Yes") {
//             if (doc.exists) {
//                 console.log("get worked and data does exist" + doc.data().coffeeAvailability)
//                 //Previously voted No and now voting Yes, add +2
//                 if (doc.data().coffeeAvailability === false && e.target.value === "Yes") {
//                      setVotedText("Thank you for helping others know it is still available");
//                      batch.set(userVoteRef, { 
//                          coffeeAvailability: true,
//                          createdTime: firebase.firestore.FieldValue.serverTimestamp(),
//                      });
//                      batch.update(coffeeVoteRef, {
//                          coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(2) 
//                      });
//                       await batch.commit();
//                  //Previously voted yes and now No, add -2
//                 } else if (doc.data().coffeeAvailability === true && e.target.value === "No") {
//                      setVotedText("Thank you for helping others know it is no longer available")
//                      batch.set(userVoteRef, { 
//                          coffeeAvailability: false,
//                          createdTime: firebase.firestore.FieldValue.serverTimestamp(),
//                          uid: auth.user.id,   
//                      });
//                      batch.update(coffeeVoteRef, {
//                          coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(-2) 
//                      });
//                       await batch.commit();
//                  //Previously voted Yes and now Yes, do nothing but show text
//                 } else if (doc.data().coffeeAvailability === true && e.target.value === "Yes") {
//                  setVotedText("Thank you for helping others know it is still available");
//                  //Previoulsy voted No and now No, do nothing but show text
//                 } else if (doc.data().coffeeAvailability === false && e.target.value === "No") {
//                  setVotedText("Thank you for helping others know it is no longer available");
//                 }
//             }}

//        //First time voting yes
//         } else if (e.target.value === "Yes" ) {           
//         setVotedText("Thank you for helping others know it is still available")
//             batch.set(userVoteRef, { 
//                 coffeeAvailability: true,
//                 createdTime: firebase.firestore.FieldValue.serverTimestamp(),
//                 uid: auth.user.id,   
//             });
//             batch.update(coffeeVoteRef, {
//                 coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(1) 
//             });
//               await batch.commit();

//         //First time voting no
//         } else if (e.target.value === "No") {            
//             setVotedText("Thank you for helping others know it is no longer available")
//             batch.set(userVoteRef, { 
//                 coffeeAvailability: false,
//                 createdTime: firebase.firestore.FieldValue.serverTimestamp(),
//                 uid: auth.user.id,   
//             });
//             batch.update(coffeeVoteRef, {
//                 coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(-1) 
//             });
//               await batch.commit();
//         }}
//    }



// batch with only reading if doc exists that is working
// const handleVoteClick = async (e) => {
//     if (!auth.user) {
//         router.push("/auth/signup")

//         } else {
//        //Hide buttons onClick
//        setShowButton(false);

//        const userVoteRef = firebase.firestore().doc(`/coffee/${coffeeId}/voting/${firebase.auth().currentUser.uid}_${coffeeId}`)           
//        const coffeeVoteRef = firebase.firestore().collection('coffee').doc(coffeeId)
//        const batch = firebase.firestore().batch();
//        const doc = await userVoteRef.get(); 
//        if (doc.exists) {
//            console.log("Document exists and data recorded is: " + doc.data().coffeeAvailability);
//         setVotedText("Thank you for helping others know")
//            //do nothing               
//         } else {
//        //increment +1 or -1 if they click yes or no
//        if (e.target.value === "Yes") {           
//        setVotedText("Thank you for helping others know it is still available")
//         batch.set(userVoteRef, { 
//             coffeeAvailability: true,
//             createdTime: firebase.firestore.FieldValue.serverTimestamp(),
//             uid: auth.user.id,
//             coffeeId: coffeeId,    
//         });
//         batch.update(coffeeVoteRef, {
//             coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(1) 
//         });
//         await batch.commit();

//         } else if (e.target.value === "No") {            
//         setVotedText("Thank you for helping others know it is no longer available")
//         batch.set(userVoteRef, { 
//             coffeeAvailability: false,
//             createdTime: firebase.firestore.FieldValue.serverTimestamp(),
//             uid: auth.user.id,
//             coffeeId: coffeeId,    
//         });
//         batch.update(coffeeVoteRef, {
//             coffeeAvailabilityVote: firebase.firestore.FieldValue.increment(-1) 
//         });
//         await batch.commit();
//          }}
//         }

//          //reset counter to 0 and new coffee availability
//        resetVote();
//    }   






// {/* <div className="vote-available">
// {votedText}
// {showButton && 
// [<FaRegThumbsUp color="#606c38" size={25} title="Yes"  />, 
// <FaRegThumbsDown color="#6a040f" size={25} title="No" />].map((icon, index) =>
// <Button
//     type="radio"
//     key={index}
//     value="1"
//     onClick={(e) => handleVoteClick(e)}
// >
//     <span className="vote mx-1">{icon}</span>
// </Button>
//     )}
// </div>  */}

